export default [...Array(24)].map((_, i) => {
  return {
    key: i + 1,
    value: i + 1,
    text: i + '時台',
  };
});
